
import { granjaApi } from "../../api";
import Swal from "sweetalert2";






export const startCategoriaXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await granjaApi.get(`/categorias/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}



export const startListadoCategorias = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/categorias', { params });
        // useBodegasStore.setState({ totalBodega: data.total });
        return data.data;
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}





export const startSavingCategoria = async(categoria) => {
    try {
        if( categoria.id ){
            await granjaApi.put(`/categorias/${categoria.id}`, categoria);
            Swal.fire('Exitoso', 'Categoria Actualizada', 'success');
        }else {
            await granjaApi.post('/categorias/new', categoria);
            Swal.fire('Exitoso', 'Categoria Creada', 'success');
        }
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 

    


